import React from 'react';
import Table from 'react-bootstrap/Table';
import PropTypes from 'prop-types';
import { statusIconFormatter } from '../../utils/common';

const createTableRow = (row, tableHeaders) => (
  row.map((cell, i) => (<td key={`${row[0]}${tableHeaders[i]}`}>{cell}</td>))
);

/**
 * function
 * - returns HTML table
 * @param {Array} tableHeaders - Array of Strings, representing Table Headers
 * @param {Array} tableData - Array of Arrays, first element is Table Header
 */
function StatisticsTable({ tableHeaders = [''], tableData = [['']] }) {
  return (
    <Table striped bordered hover>
      <thead>
        <tr>
          {tableHeaders.map(cell => (<th key={cell}>{statusIconFormatter(cell)}</th>))}
        </tr>
      </thead>
      <tbody>
        {tableData.map(row => <tr key={row[0]}>{createTableRow(row, tableHeaders)}</tr>)}
      </tbody>
    </Table>

  );
}

StatisticsTable.propTypes = {
  tableHeaders: PropTypes.array,
  tableData: PropTypes.arrayOf(PropTypes.array),
};

export default StatisticsTable;
